'use strict';

/* ************* name ***************

*******************************************/
angular.module('util.trsLegendBigFaceModule', []).directive('trsLegendBigFace', ['trsHttpService', '$filter', '$timeout', 'globleParamsSet', '$q',
    function(trsHttpService, $filter, $timeout, globleParamsSet, $q) {
        return {
            restrict: 'E',
            scope: {
                draftInfo: '=',
                switch: '=',
                totalContrast: '=' // 是否进行总图说痕迹对比，例如app渠道和报纸渠道是没有总图说的，默认对比
            },
            replace: true,
            templateUrl: './components/util/trsBigFace/trsLegendBigFace/trsLegendBigFace.html',
            link: function(scope) {
                init();

                /**
                 * [init description] 初始化数据
                 * @return {[type]} [description]
                 */
                function init() {
                    scope.status = {};
                    scope.data = {
                        picUrlObj: {} // 用来存放图片，在对比结果中没有
                    };
                    watchSwitch(function() {
                        scope.data.diffEditCost = 8;
                        openBigFace();
                    }, function() {
                        closeBigFace();
                    });
                }

                /**
                 * [openBigFace description] 开始渲染大花脸
                 * @return {[type]} [description]
                 */
                function openBigFace() {
                    var versionData;
                    if (!Number(scope.draftInfo.METADATAID)) {return;} // 如果没有METADATAID或者METADATAID为0则停止渲染
                    $q.all([getMetaViewDataVersions('mlf_appendixversion', 'getAppendixVersions'), getMetaViewDataVersions('mlf_extversion', 'getMetaViewDataVersions')]).then(function(data) {
                        versionData = $.extend(data[0], data[1]);
                        scope.data.picUrlObj = {};
                        for (var key in versionData) {
                            if (!versionData[key].length) {
                                continue;
                            }
                            scope.data.picUrlObj[key] = versionData[key][0].URL;
                            var item = versionData[key];
                            var prevName = item[0].TRUENAME;
                            item[0].CONTENT = item[0].CONTENT || '';
                            item[0].CONTENT = '<p>' + item[0].CONTENT + '</p>';
                            // 前几个版本都是同一个人时，则只显示这个人的最后一个版本，并且将版本号重新排列
                            for (var i = 1; i < item.length; i++) {
                                item[i].CONTENT = '<p>' + item[i].CONTENT + '</p>';
                                if (prevName !== item[i].TRUENAME) {
                                    prevName = '';
                                    item[i].VERSIONNUM = i + 1 + '';
                                } else {
                                    item[i].VERSIONNUM = i + '';
                                    item.splice(i - 1, 1);
                                    i--;
                                }
                            }
                        }
                        return loadBigFace();
                    }).then(function() {
                        constructingData(versionData);
                    });
                }

                /**
                 * [handleText description]处理文字
                 * @param   {[type]}  range  [range description]
                 * @return  {[type]}         [return description]
                 */
                scope.handleText = function(range) {
                    range.USERNUM = range.USERNUM || scope.data.crTimeObj[range.CRTIME];
                    if (range.type !== '=') {
                        range.htmlContent = [
                            range.fragment.replace(/\n/g, '<br/>').replace(/\u3000/g, "<span opertype='" + range.opertype + "' class='space-bg" + range.USERNUM + "'>\u3000</span>")
                        ].join('');
                    } else {
                        range.USERNUM = 1;
                        range.fragment = range.fragment.replace(/<(p)[^>]*>/ig, '');
                        range.htmlContent = [
                            range.fragment.replace(/\n/g, '<br/>')
                        ].join('');
                    }
                };

                /**
                 * [constructingData description]这就开始构造大花脸数据
                 *
                 * @param   {[type]}  versionData  [versionData description]
                 *
                 * @return  {[type]}               [return description]
                 */
                function constructingData(versionData) {
                    var version = [];
                    scope.data.results = {};
                    scope.data.resultsTitle = {};
                    scope.data.versionData = {}; // 存储基础版本，用来显示原文
                    scope.data.versionDataTitle = ''; // 存储基础版本，用来显示标题
                    var timeObj = {};
                    var key = '';
                    for (key in versionData) {
                        if (!versionData[key].length) {
                            continue;
                        }
                        // scope.data.versionData[key] = versionData[key][0];
                        var orgDataArray = versionData[key][0].CONTENT.split('\n');
                        scope.data.versionData[key] = orgDataArray.map(function(value, index, array) {
                            return value = '<span>' + value + '</span>';
                        }).join('<br/>');
                        scope.data.versionDataTitle = versionData['forTitle'][0].TITLE;
                        if(key=='forTitle'){
                        	if(versionData[key][0].TITLE){
	                        	scope.status.bigfaceTitle = new trs.BigFace('TITLE', scope.data.diffEditCost);
	                        	var resultsTitle = scope.status.bigfaceTitle.execute(versionData[key]);
	                        }
	                        if (resultsTitle !== undefined) {
	                            for (var i = 0; i < resultsTitle.length; i++) { // 给修改痕迹相应的颜色，按照时间点给
	                                var range = resultsTitle[i];
	                                timeObj[range.CRTIME] = true;
	                                range.opertype = range.type === '+' ? 'add' : (range.type === '-' ? 'sub' : 'org');
	                                if (range.type !== '=') {
	                                    var titleWithoutOperType = range.TRUENAME + '，' + range.CRTIME;
	                                    range.title = titleWithoutOperType + '，' + (range.opertype === 'add' ? '新增' : '删除');
	                                    if (range.last && range.last === '1') {
	                                        range.title = range.TRUENAME_last + '，' + range.CRTIME_last + '新增；' + range.title;
	                                    }
	                                }
	                            }
	                        }
	                        scope.data.resultsTitle[key] = resultsTitle;
                        }else{
                        	version = version.concat(versionData[key]);
                        	scope.status.bigface = new trs.BigFace('CONTENT', scope.data.diffEditCost);
	                        var results = scope.status.bigface.execute(versionData[key]);
	                        if (results !== undefined) {
	                            for (var i = 0; i < results.length; i++) { // 给修改痕迹相应的颜色，按照时间点给
	                                var range = results[i];
	                                timeObj[range.CRTIME] = true;
	                                range.opertype = range.type === '+' ? 'add' : (range.type === '-' ? 'sub' : 'org');
	                                if (range.type !== '=') {
	                                    var titleWithoutOperType = range.TRUENAME + '，' + range.CRTIME;
	                                    range.title = titleWithoutOperType + '，' + (range.opertype === 'add' ? '新增' : '删除');
	                                    if (range.last && range.last === '1') {
	                                        range.title = range.TRUENAME_last + '，' + range.CRTIME_last + '新增；' + range.title;
	                                    }
	                                }
	                            }
	                        }
	                        scope.data.results[key] = results;
                        }
                        
                        
                    }
                    if (!version.length) {
                        scope.status.noData = true;
                        return;
                    }
                    version.sort(function(prev, next){
                        var prevTime = new Date(Date.parse(prev.CRTIME));
                        var nextTime = new Date(Date.parse(next.CRTIME));
                        return prevTime - nextTime;
                    });
                    userListBycrtime(timeObj, version);
                    scope.data.copyResults = angular.copy(scope.data.results);
                    scope.data.copyResultsTitle = angular.copy(scope.data.resultsTitle); // 用来存储修改对比结果，后面选择时间点从里面过滤
                }

                /**
                 * [delete1 description] 先按照时间排序，再按照人物聚合
                 *
                 * @param   {[type]}  timeObj  [time description]
                 * @param   {[type]}  versionData  [time description]
                 *
                 * @return  {[type]}        [return description]
                 */
                function userListBycrtime(timeObj, versionData) {
                    if (JSON.stringify(timeObj) === '{}') {
                        var len = versionData.length - 1;
                        scope.data.userList = [{
                            userName: versionData[len].TRUENAME,
                            userNum: 1,
                            userList: [versionData[len]]
                        }];
                        return;
                    }
                    scope.data.crTimeObj = {};
                    scope.data.userList = [];
                    var prevName = '';
                    var userNum = 0;
                    var obj = {};
                    for (var j = 0; j < versionData.length; j++) {
                        if (timeObj[versionData[j].CRTIME]) { // 如果某个版本没有进行修改，则不显示
                            delete timeObj[versionData[j].CRTIME];
                            var item = versionData[j];
                            if (prevName !== item.TRUENAME) {
                                prevName = item.TRUENAME;
                                if (j !== 0) {
                                    scope.data.userList.unshift(obj);
                                }
                                userNum++;
                                item.USERNUM = userNum;
                                obj = {
                                    userName: item.TRUENAME,
                                    userNum: userNum,
                                    userList: [item]
                                };
                            } else { // 将一个人连续修改的痕迹放在一起
                                item.USERNUM = userNum;
                                obj.userList.unshift(item);
                            }
                            scope.data.crTimeObj[item.CRTIME] = userNum;
                        }
                    }
                    scope.data.userList.unshift(obj);
                }

                /**
                 * [getMetaViewDataVersions description]获取稿件的历史文字版本
                 *
                 * @param   {[type]}  serviceid  [methodname description]
                 * @param   {[type]}  methodname  [methodname description]
                 *
                 * @return  {[type]}              [return description]
                 */
                function getMetaViewDataVersions(serviceid, methodname) {
                    if (scope.totalContrast && methodname === 'getMetaViewDataVersions') {
                        return;
                    }
                    var deffer = $q.defer();
                    var params = {
                        serviceid: serviceid,
                        methodname: methodname,
                        MetaDataId: scope.draftInfo.METADATAID,
                    };
                    scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get')
                        .then(function(data) {
                            if (methodname !== 'getAppendixVersions') {
                                var flag = false;
                                for(var i=0; i<data.length; i++){
                                	if(data[i].CONTENT !== ''){
                                		flag = true;
                                	}
                                }
                                var data1 = [];
                                if(flag){
                                	data1 = data;	
                                }
                                textConversion(data);
                                data = {all: data1, forTitle: data};
                            }
                            deffer.resolve(data);
                        });
                    return deffer.promise;
                }

                /**
                 * [textConversion description] 正文显示处理
                 * @param  {[type]} data [description]
                 * @return {[type]}      [description]
                 */
                function textConversion(data) {
                    for (var i = 0; i < data.length; i++) {
                        var content = angular.isUndefined(data[i].HTMLCONTENT) ? data[i].CONTENT : data[i].HTMLCONTENT; // 兼容了飞腾回写不返回HTMLCONTENT的情况
                        data[i].CONTENT = globleParamsSet.getBigFaceContent('<p>' + content + '</p>');
                    }
                }

                /**
                 * [loadBigFace description] 加载大花脸源码
                 * @return {[type]} [description]
                 */
                function loadBigFace() {
                    var deffer = $q.defer();
                    LazyLoad.js(['./lib/bigface/diff_match_patch.js?v9.0'], function() {
                        LazyLoad.js(['./lib/bigface/bigface.js?v9.0'], function() {
                            LazyLoad.css(['./lib/bigface/bigface.css?v9.0'], function() {
                                deffer.resolve();
                            });
                        });
                    });
                    return deffer.promise;
                }

                /**
                 * [closeBigFace description] 关闭大花脸
                 * @return {[type]} [description]
                 */
                function closeBigFace() {
                    scope.status = {};
                    scope.data = {};
                }

                /**
                 * [watchSwitch description] 渲染开关
                 * @param  {[type]} open  [description]
                 * @param  {[type]} close [description]
                 * @return {[type]}       [description]
                 */
                function watchSwitch(open, close) {
                    scope.$watch('switch.status', function(newV, oldV) {
                        if (newV) {
                            open();
                        } else {
                            close();
                        }
                    });
                }

                /**
                 * [selectUser description]选择指定用户，默认选中其最近的一个版本，隐藏与其无关的删除痕迹，其它版本的添加痕迹变黑。相当于与最终版本对比
                 *
                 * @param   {[type]}  user   [user description]
                 * @param   {[type]}  index  [index description]
                 *
                 * @return  {[type]}         [return description]
                 */
                scope.selectUser = function(user) {
                    scope.status.showOrg = false;
                    if (scope.status.selectedRange && scope.status.selectedUser && scope.status.selectedUser.userNum == user.userNum) {
                        delete scope.status.selectedRange;
                        delete scope.status.selectedUser;
                        scope.data.results = angular.copy(scope.data.copyResults);
                        scope.data.resultsTitle = angular.copy(scope.data.copyResultsTitle);
                        return;
                    }
                    scope.status.selectedRange = user.userList[0];
                    scope.status.selectedUser = user;
                    showModificationTrace();
                };

                /**
                 * [selectRange description]选择日期，隐藏与其无关的删除痕迹，其它版本的添加痕迹变黑。相当于与最终版本对比
                 *
                 * @param   {[type]}  result  [result description]
                 * @param   {[type]}  item    [item description]
                 *
                 * @return  {[type]}          [return description]
                 */
                scope.selectRange = function(result, item) {
                    scope.status.showOrg = false;
                    if (scope.status.selectedRange && scope.status.selectedRange === item) {
                        delete scope.status.selectedUser;
                        delete scope.status.selectedRange;
                        scope.data.results = angular.copy(scope.data.copyResults);
                        scope.data.copyResultsTitle = angular.copy(scope.data.copyResultsTitle);
                        return;
                    }
                    scope.status.selectedUser = result;
                    scope.status.selectedRange = item;
                    showModificationTrace();
                };

                /**
                 * [showModificationTrace description] 展示选中人的时间点修改痕迹
                 *
                 * @return  {[type]}  [return description]
                 */
                function showModificationTrace() {
                    scope.data.results = {};
                    scope.status.showOrg = {};
                    for (var key in scope.data.copyResults) {
                        scope.data.results[key] = [];
                        if (!scope.data.copyResults[key]) {
                            if (new Date(Date.parse(scope.data.versionData[key].CRTIME)) <= new Date(Date.parse(scope.status.selectedRange.CRTIME))) { // 当在编辑图片时新添加图片，选择时间，改时间后添加的图片不显示
                                scope.status.showOrg[key] = true;
                            }
                            continue;
                        }
                        if (scope.status.selectedUser.userNum === 1) {
                            scope.status.showOrg[key] = true;
                            continue;
                        }
                        var result = angular.copy(scope.data.copyResults[key]);
                        for (var i = 0; i < result.length; i++) {
                            var obj = angular.copy(result[i]);
                            if (result[i].CRTIME !== scope.status.selectedRange.CRTIME) {
                                if (result[i].opertype !== 'sub') { // 选择时间之后，其它的添加痕迹置黑，只title显示添加
                                    obj.USERNUM = 1;
                                    scope.data.results[key].push(obj);
                                } else {
                                    if (result[i].CRTIME_last === scope.status.selectedRange.CRTIME) { // 如果是其他人删除了你的痕迹，也要显示
                                        scope.data.results[key].push(obj);
                                    }
                                }
                            } else {
                                scope.data.results[key].push(obj);
                            }
                        }
                    }
                    for (var key in scope.data.copyResultsTitle) {
                        scope.data.resultsTitle[key] = [];
                        if (!scope.data.copyResultsTitle[key]) {
                            if (new Date(Date.parse(scope.data.versionData[key].CRTIME)) <= new Date(Date.parse(scope.status.selectedRange.CRTIME))) { // 当在编辑图片时新添加图片，选择时间，改时间后添加的图片不显示
                                scope.status.showOrg[key] = true;
                            }
                            continue;
                        }
                        if (scope.status.selectedUser.userNum === 1) {
                            scope.status.showOrg[key] = true;
                            continue;
                        }
                        var result = angular.copy(scope.data.copyResultsTitle[key]);
                        for (var i = 0; i < result.length; i++) {
                            var obj = angular.copy(result[i]);
                            if (result[i].CRTIME !== scope.status.selectedRange.CRTIME) {
                                if (result[i].opertype !== 'sub') { // 选择时间之后，其它的添加痕迹置黑，只title显示添加
                                    obj.USERNUM = 1;
                                    scope.data.resultsTitle[key].push(obj);
                                } else {
                                    if (result[i].CRTIME_last === scope.status.selectedRange.CRTIME) { // 如果是其他人删除了你的痕迹，也要显示
                                        scope.data.resultsTitle[key].push(obj);
                                    }
                                }
                            } else {
                                scope.data.resultsTitle[key].push(obj);
                            }
                        }
                    }
                }

                /**
                 * [time description] 整理时间格式
                 *
                 * @param   {[type]}  CRTIME  [CRTIME description]
                 *
                 * @return  {[type]}          [return description]
                 */
                scope.time = function(CRTIME) {
                    return new Date(Date.parse(CRTIME));
                };
            },
        };
    }
]);
